export class KeyValue {
  key: string;
  value: string;
}

export class SessionState {
  username: string;
  token: string;
}

export class ModelConfig {
  id: number;
  url: string;
  name: string;
  resx: string;
  hasPackage: boolean;
}

export class ProductConfig {
  id: number;
  idModel: number;
  url: string;
  name: string;
  xml: string;
  resx: string;
  hasPackage: boolean;
  preFilters?: PreFilter[];
}


export class PaymentOption {
  key: PaymentType;
  name: string;
}

export class DeliveryOption {
  id: number;
  name: string;
}

export class DeliveryPriceConfigITA {
  rangeMinKg: number;
  rangeMaxKg: number;
  price: number;
}

export class DeliveryPriceConfigEXT {
  nation: string;
  range_0_5kg: number;
  range_5_15kg: number;
  range_15_31_5kg: number;
  oltre_31_5kg_alKG: number;
}

export class BtnToggleConfig {
  id: number;
  sort: number;
  url: string;
  text: string;
  isMenu: boolean;
  isParameter: boolean;
  isActive: boolean;
}


export class ConfigState {
  id: string;
  model: string;
}

export class Tree {
  model: string;
  code: string;
  desc: string;
  parameters: Param[];
  hash: string;
  partialHash: string;

  get isPackage(): boolean {
    if (!this.parameters || this.parameters.length === 0) {
      return false;
    }

    return this.parameters.filter(p => !p.isPackage).length === 0;
  }
}

export class ValidParamConfig {
  page: number;
  params?: Param[];
  hidden: boolean;
  image?: string;
  isPackage?: boolean;
}

export class Param {
  id: number;
  name: string;
  type: string;
  values: ParamValue[] = [];
  selectedValue: string;
  table: string;
  reportTable: string;
  page: number;
  sort: number;
  image: boolean;
  class: string;

  noPackageValueSelected: string;

  get isPackage(): boolean {
    if (this.selectedValue === undefined
      || !this.values
      || this.values.length === 0) {
      return false;
    }

    let filtered = this.values
      .filter(v => v.value === this.selectedValue);

    if (filtered.length === 0) {
      return false;
    }

    return filtered[0].package;
  }
}

export class Format {
  format: string;
  dimensions: string;
  width: number;
  height: number;
  price: number;
  priceDiscounted: number;
  valueParam: string;
}

export class PreFilter {
  key: string;
  values: string[];
  selectedValue: string;
  showOnlyThis?: boolean;
}

export class ParamValue {
  value: string;
  package: boolean;
}

export class ViewViewerSettings {
  is3d: boolean;
  view: string;
}

export class DownloadViewerSettings {
  is3d: boolean;
  view: string;
  format: string;
  version: string;
}

export class DownloadSettings {
  type: string;
  view: string;
  format: string;
  version: string;
}

export class SaveResult {
  ok: string;
  message: string;
  tree: Tree;
}




export class DataCampionario {
  public customer: Customer;
  public billing: Customer;
  public shipmentAddress: Address;
  public billingAddress: Address;

  public shippingPrice: number;
  public totalPriceCampionario: number;

  public paymentType: PaymentType = PaymentType.Bank;
  public paymentNonce: string;
}


// export class CouponData {
  // public couponLabel: string;
  // public couponEmail: string;
  // public totalPrice: number;
// }


export class Cart {
  public shipmentNations: any[];
  public deliveryPricesItaly: DeliveryPriceConfigITA[];
  public deliveryPricesEXT: DeliveryPriceConfigEXT[];
  public deliveryFissi: string[];

  public version: number;

  public cartProducts: CartProduct[];
  public idCartRow: number;

  public checkoutStepIndex: number;
  public photoBase64: string;

  public formatoSelected: boolean;


  get currentCartProduct(): CartProduct {
    return this.cartProducts[this.cartProducts.length - 1];
  }

  public customer: Customer;
  public billing: Customer;

  public shipmentAddress: Address;
  public billingAddress: Address;

  public totalPriceProducts: number;
  public totalALLPriceStatic: number;

  public TOTALCartORDER: number;

  public paymentType: PaymentType = PaymentType.Bank;
  public paymentNonce: string;

  public SelDeliveryOption: DeliveryOption;
  public delivPrice: number;

  public deliveryOptionName: string;
  public couponLabel: string;
  public couponEmail: string;




  public getSum(total: number, num: number) {
    if (num > 0) {
      return total + num;
    } else {
      return total;
    }
  }


  // SPEDIZIONI BARTOLINI
  private delivITApesoVolumTOT(): number {
    // calcolo il peso volumetrico ITA totale
    let totITAvolum = 0;
    if (this.cartProducts) {
      this.cartProducts.forEach(r => {
        if (r.pesoVolumITA > 0) {
          totITAvolum += (r.pesoVolumITA * r.quantity);
        }
      });
    }
    return totITAvolum;
  }

  private delivEXTpesoVolumTOT(): number {
    let totEXTvolum = 0;
    if (this.cartProducts) {
      this.cartProducts.forEach(r => {
        if (r.pesoVolumEXT > 0) {
          totEXTvolum += (r.pesoVolumEXT * r.quantity);
        }
      });
    }
    return totEXTvolum;
  }

  private getDelivITAprice(): number {
    let totITAvolum = this.delivITApesoVolumTOT();
    //console.log('totITAvolum = ' + totITAvolum);
    // in base agli scaglioni di pesoVolumITA trovo il prezzo
    let returnPrice = 0;
    if (this.deliveryPricesItaly) {
      this.deliveryPricesItaly.forEach(element => {
        if (totITAvolum > element.rangeMinKg && totITAvolum <= element.rangeMaxKg) {
          returnPrice = element.price;
        }
      });
    }
    // per i prodotti (Fine-art, Carta cotone stampa, Carta fotografica stampa) aggiungo prezzo fisso a 9
    if (this.cartProducts && this.deliveryFissi) {
      this.cartProducts.forEach(r => {
        if (this.deliveryFissi.indexOf(r.productName) > -1) {
          returnPrice += 9;
        }
      });
    }
    //console.log(returnPrice);
    return returnPrice;
  }

  private getDelivEXTprice(country: string): number {
    let totEXTvolum = this.delivEXTpesoVolumTOT();
    //console.log('totEXTvolum = ' + totEXTvolum);
    // SCAGLIONI DI PREZZO DIFFERENTI DA NAZIONE A NAZIONE
    let returnPrice = 0;

    let nazioneSEL;
    if (this.shipmentAddress) {
      nazioneSEL = country;

      if (nazioneSEL !== 'IT') {
        if (this.deliveryPricesEXT) {
          let ScaglioneEXT = this.deliveryPricesEXT.filter((item: DeliveryPriceConfigEXT) => item.nation === nazioneSEL)[0];
          ////console.log(ScaglioneEXT);
          if (ScaglioneEXT) {
            if (totEXTvolum <= 5) { returnPrice = ScaglioneEXT.range_0_5kg; }
            else if (totEXTvolum > 5 && totEXTvolum <= 15) { returnPrice = ScaglioneEXT.range_5_15kg; }
            else if (totEXTvolum > 15 && totEXTvolum <= 31.5) { returnPrice = ScaglioneEXT.range_15_31_5kg; }
            else if (totEXTvolum > 31.5) {
              returnPrice =
                Number(ScaglioneEXT.range_15_31_5kg +
                  Number(ScaglioneEXT.oltre_31_5kg_alKG * Number(totEXTvolum - 31.5)));
            }
          }
        }
      }
    }
    //console.log(returnPrice);
    return returnPrice;
  }

  public recalculateDeliveryPrice() {

    this.delivPrice = 0;
    if (this.SelDeliveryOption) {
      if (this.SelDeliveryOption.id === 1) {
        let country = this.shipmentAddress.Country;
        if (country === 'IT') {
          this.delivPrice = this.getDelivITAprice();
        } else {
          this.delivPrice = this.getDelivEXTprice(country);
        }
        // return this.delivPrice;
      }
    }
    // return this.delivPrice;

  }
}



export class CartProduct {

  public idRow: number;
  public idProduct: number;

  public config: ProductConfig;
  public format: string;

  public productName: string;

  public params: Param[];

  public quantity: number;
  public price: number;

  public photoID: string;
  public photoOriginal: string;
  public photoResized: string;
  public photoBounds;

  public naturalWidth: number;
  public naturalHeight: number;

  public rounded: boolean = false;

  public cornicePrice: number;
  public additionalPrice: number;
  // public additionalPrice: number;
  // private additionalPrice(): number {
  //   return this.price * this.cornicePrice;
  // }

  public pesoVolumITA: number;
  public pesoVolumEXT: number;

  public totalPriceStatic: number;
  public totalPrice(): number {
    if (!this.quantity || isNaN(this.quantity) || this.quantity < 1) {
      this.quantity = 1;
    }
    let priceTot = this.price + this.additionalPrice;
    this.totalPriceStatic = this.quantity * priceTot;
    return this.totalPriceStatic;
  }

  constructor() { }
}

export class Address {
  public Street: string;
  public Extended: string;  // Non usata il più delle volte
  public City: string;
  public Locality: string;
  public PostalCode: string;
  public District: string; // Provincia
  public Country: string; // Nazione
}

export class Customer {
  public Name: string;
  public Surname: string;
  public Email: string;
  public Phone: string;
  public TaxCode: string;
  public VatNumber: string;
  public CodeSDI: string;
  public PEC: string;
}

export enum PaymentType {
  Bank,
  Braintree
}


export class BraintreeOptions {
  container: string;
  price: number;
  onReady?: any;
  onError?: any;
}

export class BraintreeResult {
  result: boolean;
  message: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/models.ts